module.exports = __webpack_public_path__ + "assets/img/device.4178be6a.png";